import { Controller } from 'react-hook-form'
import React from 'react'
import { Loader2 } from 'lucide-react'

import { useCarEditModalWindow } from 'src/features/CarEditModalWindow/useCarEditModalWindow'
import { CarEditModalWindowProps } from 'src/features/CarEditModalWindow/types'
import { ScrollArea } from 'src/components/shadcn/scroll-area'
import { Input } from 'src/components/shadcn/input'
import { Button } from 'src/components/shadcn/button'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'src/components/shadcn/alert-dialog'

export const CarEditModalWindow = ({
  carNumber,
  carModel,
  carBrand,
  vin,
  mileage,
  toggle,
  year,
  isVisible,
  engineType,
  isActive,
  lastServiceDate,
  nextMaintenance,
}: CarEditModalWindowProps): JSX.Element => {
  const {
    cancel,
    updateBtn,
    control,
    handleSubmit,
    onUpdate,
    isLoadingGeneral,
    title,
    fields,
  } = useCarEditModalWindow({
    carNumber,
    carModel,
    carBrand,
    vin,
    mileage,
    year,
    engineType,
    isActive,
    lastServiceDate,
    nextMaintenance,
    toggle,
  })

  return (
    <form onSubmit={handleSubmit(onUpdate)}>
      <AlertDialog open={isVisible}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="text-center">{title}</AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogDescription>
            <ScrollArea className="h-[80vh] md:h-[65vh] w-full">
              <div>
                {fields.map(({ title, name, placeHolder, inputType }) => {
                  return (
                    <React.Fragment key={name}>
                      <div className="mt-3 mb-1.5">{title}</div>
                      <Controller
                        name={name}
                        control={control}
                        render={({ field }) => (
                          <Input
                            {...field}
                            id={name}
                            type={inputType}
                            placeholder={placeHolder}
                          />
                        )}
                      />
                    </React.Fragment>
                  )
                })}
              </div>
            </ScrollArea>
          </AlertDialogDescription>
          <AlertDialogFooter>
            <AlertDialogCancel
              className="rounded-[10px]"
              onClick={toggle}
              type="button"
            >
              {cancel}
            </AlertDialogCancel>
            <Button className="rounded-[10px]" onClick={onUpdate}>
              {isLoadingGeneral ? (
                <Loader2 className="animate-spin" size={13} />
              ) : (
                updateBtn
              )}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </form>
  )
}
